import { PopoverRow } from "@/components/ui/popover-row";
import { POPOVER_SURFACE_CLASSES } from "@/lib/surface-styles";
import { cn } from "@/lib/utils";

export interface EmojiShortcodeItem {
  id: string;
  name: string;
  native: string;
}

interface EmojiShortcodePopoverProps {
  emojis: EmojiShortcodeItem[];
  onSelect: (emoji: EmojiShortcodeItem) => void;
  selectedIndex: number;
}

export function EmojiShortcodePopover({
  emojis,
  onSelect,
  selectedIndex,
}: EmojiShortcodePopoverProps) {
  if (emojis.length === 0) return null;

  return (
    <div className={cn(POPOVER_SURFACE_CLASSES, "w-72")}>
      {emojis.map((emoji, i) => (
        <PopoverRow
          key={emoji.id}
          isSelected={i === selectedIndex}
          className="py-1.5"
          onMouseDown={(e) => {
            e.preventDefault();
            onSelect(emoji);
          }}
        >
          <span className="w-6 shrink-0 text-center text-lg">
            {emoji.native}
          </span>
          <span className="text-muted-foreground">:{emoji.id}:</span>
        </PopoverRow>
      ))}
    </div>
  );
}
